import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  screening: "Screening",
  screeningDescription: "PEP and sanctions · all clients",
  needsReview: "Needs review",
  incomplete: "Incomplete",
  failed: "Failed",
  notChecked: "Not checked",
  openClientsReview: "Open clients review",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    screening: "Filtrage",
    screeningDescription: "PEP et sanctions · tous les clients",
    needsReview: "À revoir",
    incomplete: "Incomplet",
    failed: "Échec",
    notChecked: "Non contrôlé",
    openClientsReview: "Ouvrir la revue des clients",
  },
  es_ES: {
    screening: "Screening",
    screeningDescription: "PEP y sanciones · todos los clientes",
    needsReview: "Requiere revisión",
    incomplete: "Incompleto",
    failed: "Fallido",
    notChecked: "Sin comprobar",
    openClientsReview: "Abrir revisión de clientes",
  },
  pt_BR: {
    screening: "Triagem",
    screeningDescription: "PEP e sanções · todos os clientes",
    needsReview: "Requer revisão",
    incomplete: "Incompleto",
    failed: "Falhou",
    notChecked: "Não verificado",
    openClientsReview: "Abrir revisão de clientes",
  },
  de_DE: {
    screening: "Screening",
    screeningDescription: "PEP und Sanktionen · alle Kunden",
    needsReview: "Prüfung erforderlich",
    incomplete: "Unvollständig",
    failed: "Fehlgeschlagen",
    notChecked: "Nicht geprüft",
    openClientsReview: "Kundenprüfung öffnen",
  },
  it_IT: {
    screening: "Screening",
    screeningDescription: "PEP e sanzioni · tutti i clienti",
    needsReview: "Da revisionare",
    incomplete: "Incompleto",
    failed: "Non riuscito",
    notChecked: "Non verificato",
    openClientsReview: "Apri revisione clienti",
  },
  ar: {
    screening: "فحص القوائم",
    screeningDescription: "الأشخاص المعرّضون سياسيًا (PEP) والعقوبات · جميع العملاء",
    needsReview: "تحتاج إلى مراجعة",
    incomplete: "غير مكتمل",
    failed: "فشل",
    notChecked: "لم يُفحص",
    openClientsReview: "فتح مراجعة العملاء",
  },
  ja_JP: {
    screening: "スクリーニング",
    screeningDescription: "PEP および制裁 · 全顧客",
    needsReview: "要レビュー",
    incomplete: "未完了",
    failed: "失敗",
    notChecked: "未チェック",
    openClientsReview: "顧客レビューを開く",
  },
  hi_IN: {
    screening: "स्क्रीनिंग",
    screeningDescription: "PEP और प्रतिबंध · सभी क्लाइंट",
    needsReview: "समीक्षा आवश्यक",
    incomplete: "अपूर्ण",
    failed: "विफल",
    notChecked: "जाँच नहीं हुई",
    openClientsReview: "क्लाइंट समीक्षा खोलें",
  },
  zh_CN: {
    screening: "筛查",
    screeningDescription: "PEP 与制裁 · 全部客户",
    needsReview: "需审核",
    incomplete: "不完整",
    failed: "失败",
    notChecked: "未检查",
    openClientsReview: "打开客户审核",
  },
  zh_TW: {
    screening: "篩檢",
    screeningDescription: "PEP 與制裁 · 所有客戶",
    needsReview: "需審核",
    incomplete: "不完整",
    failed: "失敗",
    notChecked: "未檢查",
    openClientsReview: "開啟客戶審核",
  },
  nl_NL: {
    screening: "Screening",
    screeningDescription: "PEP en sancties · alle klanten",
    needsReview: "Beoordeling nodig",
    incomplete: "Onvolledig",
    failed: "Mislukt",
    notChecked: "Niet gecontroleerd",
    openClientsReview: "Klantbeoordeling openen",
  },
  nb_NO: {
    screening: "Screening",
    screeningDescription: "PEP og sanksjoner · alle kunder",
    needsReview: "Må gjennomgås",
    incomplete: "Ufullstendig",
    failed: "Feilet",
    notChecked: "Ikke sjekket",
    openClientsReview: "Åpne kundegjennomgang",
  },
  sv_SE: {
    screening: "Screening",
    screeningDescription: "PEP och sanktioner · alla kunder",
    needsReview: "Behöver granskas",
    incomplete: "Ofullständig",
    failed: "Misslyckad",
    notChecked: "Ej kontrollerad",
    openClientsReview: "Öppna kundgranskning",
  },
  fi_FI: {
    screening: "Seulonta",
    screeningDescription: "PEP ja pakotteet · kaikki asiakkaat",
    needsReview: "Vaatii tarkastusta",
    incomplete: "Keskeneräinen",
    failed: "Epäonnistui",
    notChecked: "Ei tarkistettu",
    openClientsReview: "Avaa asiakkaiden tarkastus",
  },
  da_DK: {
    screening: "Screening",
    screeningDescription: "PEP og sanktioner · alle kunder",
    needsReview: "Kræver gennemgang",
    incomplete: "Ufuldstændig",
    failed: "Mislykkedes",
    notChecked: "Ikke kontrolleret",
    openClientsReview: "Åbn kundegennemgang",
  },
  is_IS: {
    screening: "Skimun",
    screeningDescription: "PEP og þvinganir · allir viðskiptavinir",
    needsReview: "Þarfnast yfirferðar",
    incomplete: "Ófullgert",
    failed: "Mistókst",
    notChecked: "Ekki athugað",
    openClientsReview: "Opna yfirferð viðskiptavina",
  },
};
